// Audio asset metadata for dynamic rendering in Avatar.js
// Generated from sample-audio-data.csv

// Import all audio files
import dncIvrAudio from "../assets/Recordings/DNC-IVR.mp3";
import hello1Audio from "../assets/Recordings/greetings/Hello1.mp3";
import hello2Audio from "../assets/Recordings/greetings/Hello2.mp3";
import bettyIntroAudio from "../assets/Recordings/greetings/Intro Betty.mp3";
import introLindaAudio from "../assets/Recordings/greetings/Intro Linda.mp3";
import introMarthaAudio from "../assets/Recordings/greetings/Intro Martha.mp3";
import joyceIntroAudio from "../assets/Recordings/greetings/Intro Joyce.mp3";
import yesMamAudio from "../assets/Recordings/greetings/Yes mam.mp3";
import yesSirAudio from "../assets/Recordings/greetings/Yes sir. .mp3";
import reason1Audio from "../assets/Recordings/reason/Reason 1.mp3";
import reason2Audio from "../assets/Recordings/reason/Reason 2.mp3";
import reason3Audio from "../assets/Recordings/reason/Reason 3.mp3";
import age1Audio from "../assets/Recordings/age/Age 1.mp3";
import ageRebutAudio from "../assets/Recordings/age/Age Rebut.mp3";
import decisionMaker1Audio from "../assets/Recordings/age/Decision maker 1.mp3";
import decisionMaker2Audio from "../assets/Recordings/age/Decision maker 2.mp3";
import notInterestedAudio from "../assets/Recordings/objections/NOT INTERESTED.mp3";
import alreadyHaveInsuranceAudio from "../assets/Recordings/objections/ALREADY HAVE INSURANCE.mp3";
import notRightNowAudio from "../assets/Recordings/objections/NOT RIGHT NOW.mp3";
import affordabilityIssueAudio from "../assets/Recordings/objections/Affordability issue.mp3";
import calledBeforeAudio from "../assets/Recordings/objections/Called Before.mp3";
import optin1Audio from "../assets/Recordings/optin/Optin 1.mp3";
import transferLine1Audio from "../assets/Recordings/optin/Transfer line 1.mp3";
import transferLine2Audio from "../assets/Recordings/optin/Transfer line 2.mp3";
import transferLine3Audio from "../assets/Recordings/optin/Transfer line 3.mp3";
import yesAudio from "../assets/Recordings/replies/Yes.mp3";
import noAudio from "../assets/Recordings/replies/No.mp3";
import okayAudio from "../assets/Recordings/replies/Okay.mp3";
import greatAudio from "../assets/Recordings/replies/Great.mp3";
import thankYouForAskingAudio from "../assets/Recordings/replies/Thank you for asking.mp3";
import sorryAudio from "../assets/Recordings/replies/Sorry.mp3";
import laughAudio from "../assets/Recordings/replies/Laugh.mp3";
import fineThankYouAudio from "../assets/Recordings/replies/Fine thankyou.mp3";
import gladToHearAudio from "../assets/Recordings/replies/Glad to hear.mp3";
import canYouHearMeNowAudio from "../assets/Recordings/replies/Can you hear me now .mp3";
import areYouThereAudio from "../assets/Recordings/replies/Are you there.mp3";
import hold1Audio from "../assets/Recordings/hold/HOLD 1.mp3";
import hold2Audio from "../assets/Recordings/hold/HOLD 2.mp3";
import rescueAudio from "../assets/Recordings/hold/RESCUE.mp3";
import verifierBusyAudio from "../assets/Recordings/hold/VERIFIER BUSY.mp3";
import whatIsFinalExpenseAudio from "../assets/Recordings/faqs/What is final Expense Insuranc.mp3";
import whatIsThisCallAboutAudio from "../assets/Recordings/faqs/WHAT IS THIS CALL ABOUT.mp3";
import howDidYouGetMyInformationAudio from "../assets/Recordings/faqs/How did you get my information.mp3";
import companyNameLocatedAudio from "../assets/Recordings/faqs/COMPANY NAME LOCATED.mp3";
import canYouRepeatAudio from "../assets/Recordings/faqs/Can you repeat.mp3";
import weatherAudio from "../assets/Recordings/faqs/WEATHER.mp3";

import howMuchWillItCostAudio from "../assets/Recordings/faqs/How much will it cost.mp3";
import bettyAndersonFullNameAudio from "../assets/Recordings/full-names/Betty Anderson.mp3";
import joyceAndersonFullNameAudio from "../assets/Recordings/full-names/Joyce Anderson.mp3";
import lindaAndersonFullNameAudio from "../assets/Recordings/full-names/Linda Anderson.mp3";
import marthaAndersonFullNameAudio from "../assets/Recordings/full-names/Martha Anderson.mp3";

// Category display name mappings
export const categoryDisplayNames = {
  greetings: {
    label: "Greetings & Intros",
    colors: {
      primary: "#27ae60",
      gradient: "#2ecc71",
    },
  },
  reason: {
    label: "Reason for Call (Hook Lines)",
    colors: {
      primary: "#3498db",
      gradient: "#5dade2",
    },
  },
  age: {
    label: "Age & Eligibility",
    colors: {
      primary: "#9b59b6",
      gradient: "#bb8fce",
    },
  },
  objections: {
    label: "Objection Handling",
    colors: {
      primary: "#e74c3c",
      gradient: "#ec7063",
    },
  },
  optin: {
    label: "Opt-in & Transition",
    colors: {
      primary: "#f39c12",
      gradient: "#f7dc6f",
    },
  },
  replies: {
    label: "Basic Replies & Soft Prompts",
    colors: {
      primary: "#16a085",
      gradient: "#1abc9c",
    },
  },
  hold: {
    label: "Hold & Rescue",
    colors: {
      primary: "#34495e",
      gradient: "#5d6d7e",
    },
  },
  faqs: {
    label: "FAQs & Responses",
    colors: {
      primary: "#e67e22",
      gradient: "#f39c12",
    },
  },
  fullnames: {
    label: "Full Names",
    colors: {
      primary: "#8e44ad",
      gradient: "#a569bd",
    },
  },
};

const audioData = [
  // DNC IVR
  {
    label: "DNC IVR",
    file: dncIvrAudio,
    category: "special",
    description: "Do Not Call IVR system",
  },

  // Greetings & Intros
  {
    label: "Hello 1",
    file: hello1Audio,
    category: "greetings",
    description: "Hello hey.",
  },
  {
    label: "Hello 2",
    file: hello2Audio,
    category: "greetings",
    description: "Hello can you hear me?",
  },

  {
    label: "Betty Intro",
    file: bettyIntroAudio,
    category: "greetings",
    description: "Intro by Betty.",
  },
  {
    label: "Intro Linda",
    file: introLindaAudio,
    category: "greetings",
    description: "Intro by Linda.",
  },
  {
    label: "Intro Martha",
    file: introMarthaAudio,
    category: "greetings",
    description: "Intro by Martha.",
  },

  {
    label: "Intro Joyce",
    file: joyceIntroAudio,
    category: "greetings",
    description: "Intro by Joyce.",
  },

  {
    label: "Yes ma'am",
    file: yesMamAudio,
    category: "greetings",
    description: "Yes ma'am.",
  },
  {
    label: "Yes sir",
    file: yesSirAudio,
    category: "greetings",
    description: "Yes sir.",
  },

  // Reason for Call (Hook Lines)
  {
    label: "Reason 1",
    file: reason1Audio,
    category: "reason",
    description: "Trump bill may affect senior benefits... how old are you?",
  },
  {
    label: "Reason 2",
    file: reason2Audio,
    category: "reason",
    description: "Reason 2 audio.",
  },
  {
    label: "Reason 3",
    file: reason3Audio,
    category: "reason",
    description: "Reason 3 audio.",
  },

  // Age & Eligibility
  {
    label: "Age 1",
    file: age1Audio,
    category: "age",
    description: "Now to generate the best pricing how old are you?",
  },
  {
    label: "Age Rebut",
    file: ageRebutAudio,
    category: "age",
    description: "test rebuttal",
  },
  {
    label: "Decision maker 1",
    file: decisionMaker1Audio,
    category: "age",
    description: "Can you make decisions for yourself?",
  },
  {
    label: "Decision maker 2",
    file: decisionMaker2Audio,
    category: "age",
    description: "Are you the one who makes your own decisions?",
  },

  // Objection Handling
  {
    label: "Not Interested",
    file: notInterestedAudio,
    category: "objections",
    description:
      "These are newly approved affordable plans—our agent can give you a free quote.",
  },
  {
    label: "Already Have insurance 1",
    file: alreadyHaveInsuranceAudio,
    category: "objections",
    description: "Funeral costs are rising—our agent can still help.",
  },
  {
    label: "Not Right Now",
    file: notRightNowAudio,
    category: "objections",
    description:
      "I understand—this won't take long and it might save you money. OKAY?",
  },
  {
    label: "Affordability issue",
    file: affordabilityIssueAudio,
    category: "objections",
    description:
      "These new plans have low monthly premiums recently approved in your state.",
  },
  {
    label: "Called Before",
    file: calledBeforeAudio,
    category: "objections",
    description: "That likely wasn't us—this will just take a few minutes.",
  },

  // Opt-in & Transition
  {
    label: "Optin 1",
    file: optin1Audio,
    category: "optin",
    description: "So is that OKAY with you?",
  },
  {
    label: "Transfer Line 1",
    file: transferLine1Audio,
    category: "optin",
    description:
      "You're good to go—connecting you now with a licensed advisor. Just hold on:",
  },
  {
    label: "Transfer Line 2",
    file: transferLine2Audio,
    category: "optin",
    description:
      "That's all I need—let me get my insurance consultant on the line. Just one second",
  },
  {
    label: "Transfer Line 3",
    file: transferLine3Audio,
    category: "optin",
    description: "Transfer line 3 audio.",
  },

  // Basic Replies & Soft Prompts
  {
    label: "Yes",
    file: yesAudio,
    category: "replies",
    description: "Yes",
  },
  {
    label: "No",
    file: noAudio,
    category: "replies",
    description: "No",
  },
  {
    label: "Okay",
    file: okayAudio,
    category: "replies",
    description: "Okay",
  },
  {
    label: "Great",
    file: greatAudio,
    category: "replies",
    description: "Great.",
  },
  {
    label: "Thank you for asking",
    file: thankYouForAskingAudio,
    category: "replies",
    description: "Thank you for asking",
  },
  {
    label: "Sorry",
    file: sorryAudio,
    category: "replies",
    description: "Sorry",
  },
  {
    label: "Laugh",
    file: laughAudio,
    category: "replies",
    description: "Laugh",
  },
  {
    label: "Fine thankyou",
    file: fineThankYouAudio,
    category: "replies",
    description: "Fine thank you.",
  },
  {
    label: "Glad to hear",
    file: gladToHearAudio,
    category: "replies",
    description: "Glad to hear.",
  },
  {
    label: "Can you hear me now",
    file: canYouHearMeNowAudio,
    category: "replies",
    description: "Can you hear me now?",
  },
  {
    label: "Are you there",
    file: areYouThereAudio,
    category: "replies",
    description: "Are you there?",
  },

  // Hold & Rescue
  {
    label: "Hold 1",
    file: hold1Audio,
    category: "hold",
    description: "Just a second.",
  },
  {
    label: "Hold 2",
    file: hold2Audio,
    category: "hold",
    description: "Hold on just a moment okay?",
  },
  {
    label: "Rescue",
    file: rescueAudio,
    category: "hold",
    description: "I'm new here let me connect you to a specialist.",
  },
  {
    label: "Verifier Busy",
    file: verifierBusyAudio,
    category: "hold",
    description: "All verifiers are busy—please stay on the line.",
  },

  // FAQs & Responses
  {
    label: "What is final expense",
    file: whatIsFinalExpenseAudio,
    category: "faqs",
    description: "A life insurance policy for funeral burial and cremation.",
  },
  {
    label: "What is this call about",
    file: whatIsThisCallAboutAudio,
    category: "faqs",
    description: "Final expense insurance to cover funeral and burial costs.",
  },
  {
    label: "How did you get my information",
    file: howDidYouGetMyInformationAudio,
    category: "faqs",
    description: "How did you get my information?",
  },
  {
    label: "Company Name Located",
    file: companyNameLocatedAudio,
    category: "faqs",
    description: "Company Name Located.",
  },
  {
    label: "Can you repeat",
    file: canYouRepeatAudio,
    category: "faqs",
    description: "Can you repeat?",
  },
  {
    label: "How much will it cost",
    file: howMuchWillItCostAudio,
    category: "faqs",
    description: "How much will it cost?",
  },
  {
    label: "Weather",
    file: weatherAudio,
    category: "faqs",
    description: "Weather.",
  },
  // Full Names Category
  {
    label: "Betty Anderson",
    file: bettyAndersonFullNameAudio,
    category: "fullnames",
    description: "Full name: Betty Anderson.",
  },
  {
    label: "Joyce Anderson",
    file: joyceAndersonFullNameAudio,
    category: "fullnames",
    description: "Full name: Joyce Anderson.",
  },
  {
    label: "Linda Anderson",
    file: lindaAndersonFullNameAudio,
    category: "fullnames",
    description: "Full name: Linda Anderson.",
  },
  {
    label: "Martha Anderson",
    file: marthaAndersonFullNameAudio,
    category: "fullnames",
    description: "Full name: Martha Anderson.",
  },
];

// Category display name mappings

export default audioData;
